import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(function () {
    // Animation
    let defaultEase = "circ.inOut";

    function loadAnimation() {
        setTimeout(() => {
            // Hero
            gsap.to(".department .department-hero .title", {
                y: 0,
                opacity: 1,
                duration: 0.8,
                ease: defaultEase
            })
       
            gsap.to(".department .department-hero .title .img", {
                x: 0,
                opacity: 1,
                duration: 0.8,
                ease: defaultEase
            })

            gsap.to(".department .department-hero p", {
                y: 0,
                opacity: 1,
                delay: 0.1,
                duration: 0.8,
                ease: defaultEase
            })

            // Title
            gsap.to(".department .department-titles .title-col:nth-child(1) .title-wrapper", {
                x: -400,

                scrollTrigger: {
                    trigger: ".department .department-titles",
                    start: "top bottom",
                    end: "top top",
                    scrub: 1.1,
                }
            })

            gsap.to(".department .department-titles .title-col:nth-child(2) .title-wrapper", {
                x: 400,

                scrollTrigger: {
                    trigger: ".department .department-titles",
                    start: "top bottom",
                    end: "bottom top",
                    scrub: 1.1,
                }
            })

            // Other Services
            gsap.to(".other-services .page-title", {
                y: 0,
                opacity: 1,

                scrollTrigger: {
                    trigger: ".other-services",
                    start: "top bottom-=200px",
                }
            })

            gsap.to(".other-services .services-list .list-item", {
                y: 0,
                opacity: 1,
                stagger: 0.1,

                scrollTrigger: {
                    trigger: ".other-services",
                    start: "top bottom-=200px",
                }
            })
        }, 500);
    }

    if ($(window).width() >= 1200) {
        loadAnimation();
    }

    $(window).resize(function () {
        if ($(window).width() >= 1200) {
            loadAnimation();
        }
    });
})